module.exports = __webpack_public_path__ + "img/wloding.3295ba5e.png";